
  // Force BMSM variant dropdowns to always use non-modal show() instead of showModal()
  (function() {
    function patchDialogs() {
      document.querySelectorAll('.hdt-buy-more-save-more-section .hdt-popover-variant').forEach(function(dialog) {
        if (dialog._bmsmPatched) return;
        dialog._bmsmPatched = true;
        dialog.showModal = function() {
          if (!this.open) this.show();
        };
      });
    }
    patchDialogs();
    document.addEventListener('DOMContentLoaded', patchDialogs);
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(patchDialogs).observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('click', function(e) {
      document.querySelectorAll('.hdt-buy-more-save-more-section .hdt-popover-variant[open]').forEach(function(dialog) {
        var popover = dialog.closest('hdt-popover');
        var trigger = popover ? popover.previousElementSibling : null;
        if (!dialog.contains(e.target) && e.target !== trigger && (!trigger || !trigger.contains(e.target))) {
          dialog.close();
        }
      });
    });
  })();

  function selectBundle(el, qty) {
    const section = el.closest('.hdt-buy-more-save-more-section');
    section.querySelectorAll('.hdt-bmsm-bundle-row').forEach(i => {
      i.classList.remove('active');
      const radio = i.querySelector('input[type="radio"]');
      if (radio) radio.checked = false;
    });
    el.classList.add('active');
    const activeRadio = el.querySelector('input[type="radio"]');
    if (activeRadio) activeRadio.checked = true;
    const form = section.querySelector('form');
    if (form) {
      form.querySelector('input[name="quantity"]').value = qty;
    }
  }

  // Boomba Product Switcher logic
  document.querySelectorAll('.hdt-buy-more-save-more-section .custom-listing-item').forEach(item => {
    item.addEventListener('click', () => {
      const section = item.closest('.hdt-buy-more-save-more-section');
      section.querySelectorAll('.custom-listing-item').forEach(i => i.classList.remove('cat-active'));
      section.querySelectorAll('.tab-content').forEach(c => c.classList.remove('active'));
      item.classList.add('cat-active');
      const targetId = item.dataset.target;
      section.querySelector('#' + targetId).classList.add('active');
    });
  });

  // Variant image handler
  document.addEventListener('DOMContentLoaded', () => {
    const scripts = document.querySelectorAll('script[id^="bmsm-variant-images-"]');
    scripts.forEach(script => {
      const section = script.closest('.hdt-buy-more-save-more-section');
      if (!section) return;

      let variantImages = {};
      try {
        variantImages = JSON.parse(script.textContent);
      } catch(e) {}

      if (Object.keys(variantImages).length === 0) return;

      function updateImages() {
        const selectedOptions = Array.from(section.querySelectorAll('.hdt-variant-picker input[type="radio"]:checked, .hdt-variant-picker select'))
          .map(el => el.value.toLowerCase().trim());

        let matchedImages = null;
        for (const opt of selectedOptions) {
          if (variantImages[opt]) {
            matchedImages = variantImages[opt];
            break;
          }
        }

        if (matchedImages) {
          const bundles = section.querySelectorAll('.hdt-bmsm-bundle-row');
          bundles.forEach((bundle, index) => {
            if (matchedImages[index]) {
              let imgEl = bundle.querySelector('.hdt-bmsm-bundle-img');
              if (imgEl) {
                imgEl.src = matchedImages[index];
                imgEl.srcset = matchedImages[index];
                let wrapper = imgEl.closest('.hdt-bmsm-bundle-thumb');
                if (wrapper) wrapper.style.display = 'relative';
              } else {
                const thumb = bundle.querySelector('.hdt-bmsm-bundle-thumb');
                if (thumb) {
                  const newImg = document.createElement('img');
                  newImg.className = 'hdt-bmsm-bundle-img';
                  newImg.src = matchedImages[index];
                  thumb.insertBefore(newImg, thumb.firstChild);
                  thumb.style.display = 'relative';
                }
              }
            }
          });
        }
      }

      section.addEventListener('change', (e) => {
        if (e.target.closest('hdt-variant-picker')) {
          updateImages();
        }
      });
      setTimeout(updateImages, 100);
    });
  });

  // Size label update logic
  document.addEventListener('change', (e) => {
    const target = e.target;
    if (target.matches('hdt-richlist') || (target.tagName === 'INPUT' && target.closest('fieldset.is-style-size'))) {
      const fieldset = target.closest('fieldset.is-style-size');
      if (!fieldset) return;

      const sizeEquivalents = {
        'AA': '28A, 30A, 32A, 28B, 30B, 28C',
        'A': '34A, 32B, 30C, 28D',
        'B': '36A, 34B, 32C, 30D, 28DD',
        'C': '38A, 36B, 34C, 32D, 30DD, 28E',
        'D': '40A, 38B, 36C, 34D, 32DD, 30E, 28F',
        'E': '42A, 40B, 38C, 36D, 34DD, 32E, 30F, 28FF',
        'F': '44A, 42B, 40C, 38D, 36DD, 34E, 32F, 30FF, 28G',
        'G': '44B, 42C, 40D, 38DD, 36E, 34F, 32FF, 30G, 28GG',
        'H': '44C, 42D, 40DD, 38E, 36F, 34FF, 32G, 30GG, 28H',
        'I': '44D, 42DD, 40E, 38F, 36FF, 34G, 32GG, 30H, 28HH',
        'J': '44DD, 42E, 40F, 38FF, 36G, 34GG, 32H, 30HH, 28J',
        'K': '44E, 42F, 40FF, 38G, 36GG, 34H, 32HH, 30J, 28JJ',
        'L': '44F, 42FF, 40G, 38GG, 36H, 34HH, 32J, 30JJ, 28K',
        'M': '44FF, 42G, 40GG, 38H, 36HH, 34J, 32JJ, 30K, 28KK',
        'N': '44G, 42GG, 40H, 38HH, 36J, 34JJ, 32K, 30KK, 28L',
        'O': '42H, 40HH, 38J, 36JJ, 34K, 32KK, 30L, 28LL',
        'P': '42HH, 40J, 38JJ, 36K, 34KK, 32L, 30LL',
        'Q': '42J, 40JJ, 38K, 36KK, 34L, 32LL, 30M',
        'R': '44J, 42JJ, 40K, 38KK, 36L, 34LL, 32M, 30MM, 28N',
        'A/B': '34A, 32B, 30C, 28D',
        'C/D': '38A, 36B, 34C, 32D, 30DD/E',
        'DD/E/F': '44A, 42B, 40C, 38D, 36DD/E, 34DDD/F',
        'G/H': '44C, 42D, 40DD/E, 38DDD/F, 36G, 34H, 32I, 30J, 28K',
        'I/J/K': '44D, 42DD/E, 40DDD/F, 38G, 36H, 34I, 32J, 30K, 28L'
      };

      const val = target.getAttribute('selected') || target.value;
      if (!val) return;

      const labelSpan = fieldset.querySelector('[update-value]');
      if (labelSpan) labelSpan.textContent = val;

      const equiv = sizeEquivalents[val] || '';
      const buttonText = equiv ? `${val} fits bra sizes: ${equiv}` : `SIZE ${val}`;
      const selectBtn = fieldset.querySelector('button.hdt-select');
      if (selectBtn) {
        selectBtn.textContent = buttonText;
        checkSelectLineCount(selectBtn);
      }
    }
  });

  function checkSelectLineCount(btn) {
    if (!btn) return;
    // Remove class first so we measure in default (2-line) state
    btn.classList.remove('is-oneline');
    var style = getComputedStyle(btn);
    var lineHeight = parseFloat(style.lineHeight) || 22;
    var paddingTop = parseFloat(style.paddingTop) || 0;
    var paddingBottom = parseFloat(style.paddingBottom) || 0;
    var contentHeight = btn.scrollHeight - paddingTop - paddingBottom;
    if (contentHeight <= lineHeight * 1.3) {
      btn.classList.add('is-oneline');
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.hdt-bmsm-selector-container button.hdt-select').forEach(checkSelectLineCount);
  });
  setTimeout(function() {
    document.querySelectorAll('.hdt-bmsm-selector-container button.hdt-select').forEach(checkSelectLineCount);
  }, 300);

